import React, { useState, useEffect, useRef } from 'react';
import { Draggable } from 'react-beautiful-dnd';
import { Crown } from 'lucide-react';

import { teamCoding } from '../../them';

const STATUS_CLASSES = {
    'Active': 'bg-green-50 text-green-700 border-green-200',
    'Partially Active': 'bg-orange-50 text-orange-700 border-orange-200',
    'In Active': 'bg-blue-50 text-blue-700 border-blue-200',
};

const statusClass = (status) => STATUS_CLASSES[status] || 'bg-blue-50 text-blue-700 border-blue-200';

const TeamCard = ({ item, index }) => {
    const [menuPos, setMenuPos] = useState(null);
    const [leader, setLeader] = useState(false);
    const menuRef = useRef(null);

    useEffect(() => {
        if (!menuPos) return undefined;
        const close = (e) => {
            if (menuRef.current && !menuRef.current.contains(e.target)) setMenuPos(null);
        };
        document.addEventListener('mousedown', close);
        return () => document.removeEventListener('mousedown', close);
    }, [menuPos]);

    const handleContextMenu = (event) => {
        event.preventDefault();
        setMenuPos(menuPos === null ? { x: event.clientX + 2, y: event.clientY - 6 } : null);
    };

    const toggleLeader = () => {
        setLeader((l) => !l);
        setMenuPos(null);
    };

    const roleColor = teamCoding(item?.role?.role_name);

    return (
        <Draggable key={item.id} draggableId={`${item.id}`} index={index}>
            {(provided) => (
                <div
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                    onContextMenu={handleContextMenu}
                    className="relative mb-2"
                    style={{ cursor: 'context-menu', ...provided.draggableProps.style }}
                >
                    <div
                        className="bg-white rounded-lg shadow-sm border border-neutral-100 p-3"
                        style={{ borderLeft: `4px solid ${roleColor}` }}
                    >
                        <div className="flex items-center justify-between gap-2">
                            <div className="flex items-center gap-2.5 min-w-0">
                                <div
                                    className="w-8 h-8 rounded-full text-white flex items-center justify-center text-xs font-bold shrink-0"
                                    style={{ backgroundColor: roleColor }}
                                >
                                    {item?.role?.role_name ? item.role.role_name[0].toUpperCase() : '?'}
                                </div>
                                <p className="text-sm font-semibold text-neutral-800 truncate">{item?.fullname}</p>
                            </div>
                            {leader && <Crown className="w-4 h-4 text-orange-500 shrink-0" />}
                        </div>
                        <div className="flex items-center justify-between mt-2.5">
                            <span className="text-xs text-neutral-400 font-medium">{item?.experience}</span>
                            <span className={`text-[10px] font-semibold px-2 py-0.5 rounded-full border ${statusClass(item?.activity_status?.status)}`}>
                                {item?.activity_status?.status}
                            </span>
                        </div>
                    </div>

                    {menuPos && (
                        <div
                            ref={menuRef}
                            className="fixed z-50 bg-white rounded-lg shadow-lg border border-neutral-100 py-1 min-w-[10rem]"
                            style={{ top: menuPos.y, left: menuPos.x }}
                        >
                            <button
                                className="w-full text-left px-4 py-2 text-sm text-neutral-600 hover:bg-neutral-50"
                                onClick={toggleLeader}
                            >
                                {leader ? 'Remove Leader' : 'Make Leader'}
                            </button>
                        </div>
                    )}
                </div>
            )}
        </Draggable>
    );
};

export default TeamCard;
